var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lds-ripple",style:(_vm.marginTopStyle)},[_c('div',{class:{
      'loader-border-primary': _vm.primaryColor,
      'loader-border-white': _vm.primaryColor
    }}),_c('div',{class:{
      'loader-border-primary': _vm.primaryColor,
      'loader-border-white': _vm.whiteColor
    }})])}
var staticRenderFns = []

export { render, staticRenderFns }